export enum AssistanceCategories {
  Highlighted = 'HIGHLIGHT'
}
